import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Grid, LinearProgress } from '@mui/material';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import TreatmentPoint from '../components/Treatment/TreatmentPoint';
import IconButton from '@mui/material/IconButton';
import { Button, Menu, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import MenuIcon from '@mui/icons-material/Menu';
import EditarPonto from './Treatment/EditarPonto';
import AddPoint from './Treatment/AddPoint';
import ViewLocation from './Treatment/ViewLocation';
import ViewPicture from './Treatment/ViewPicture';
import Allowance from './Treatment/Allowance';
import ActionsTimesheet from './Treatment/ActionsTimesheet';
import DeleteTimesheet from './Treatment/DeleteTimesheet';
import MissingDay from './Treatment/MissingDay';
import NestedMenuItem from "material-ui-nested-menu-item";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import MyTable from './TableDataReport';
import ActivityWorkDay from './Treatment/ActivityWorkday';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(2),
    // display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    alignItems: 'center',
  },
  reportHeader: {
    display: 'grid',
    // flexDirection: 'column',
    alignItems: 'center',
    border: 'none'
  },
  Typography: {
    width: '100%',
    textAlign: 'left',
  },
}));

const ReportData = ({
  dataReportGroup
}) => {

  const classes = useStyles();
  const open = Boolean(dataReportGroup.openMenuTimesheet);
  const openAtividade = Boolean(dataReportGroup.anchorElAtividade);

  



  const handleMenuOpen = (event, row, day, type, timestamp) => {

    dataReportGroup.setOpenMenuTimesheet(event.currentTarget);
    dataReportGroup.setTimesheetRow(row)
    dataReportGroup.setRow(row)
    dataReportGroup.setType(type == 'Entrada' ? "I" : "O")
    // setOpenTreatmentPoint(true)
  };

  const handleOpenADDpoint = (event, row, day, type, timestamp) => {
    dataReportGroup.setOpenAddPoint(event.currentTarget)
    dataReportGroup.setTimesheetRow(day)
    dataReportGroup.setRow(day)
    dataReportGroup.setType(type == 'Entrada' ? "I" : "O")
    dataReportGroup.setIdCreatedTimesheet(timestamp)
  }

  const handleCloseAdd = () => {
    dataReportGroup.setOpenAddPoint(null);
  };

  const handleViewPicture = () => {
    dataReportGroup.getModalPicture(dataReportGroup.timesheetRow.timeclockId)
  }

  const handleMenuClose = () => {
    dataReportGroup.setOpenMenuTimesheet(false);
  };

  const count = []
  const findCountShift = dataReportGroup.data.forEach(element => count.push(element.shifts.length));
  const maxNumberShift = Math.max(...count)

  function Separador() {
    return <div style={{ margin: '10px 0', borderBottom: '2px solid #ccc' }} />;
  }
  // console.log('data', data)

  const [menuIncomplets, setMenuIncomplets] = useState(false)
  const handleMenuIncomplets = () => {
    setMenuIncomplets(true)
  }
  const handleCloseMenuIncomplets = () => {
    setMenuIncomplets(false)
  }

  const handleClickIncomplets = (event, row) => {
    // Evitar o menu padrão ao clicar com o botão direito
    event.preventDefault();
    dataReportGroup.setOpenHistory(true)
    // setMenuIncomplets(event.currentTarget);
    dataReportGroup.setRow(row)
  };

  const handleNestedMenuItemHover = (event, row) => {
    dataReportGroup.setTimesheetRow(row)
  };

  const closeModalDeleteTimesheet = () => {
    dataReportGroup.closeModalTimesheetDelete()
    dataReportGroup.handleMenuCloseAtividade()
  }



  return (

    <Grid className={classes.root}>
      {/* {
        autoFix ?
          <LinearProgress style={{ paddingTop: '10px' }} /> : null
      } */}
      {
        dataReportGroup.errorBoolean ?
          <Snackbar open={dataReportGroup.errorBoolean} autoHideDuration={3000} onClose={dataReportGroup.handleCloseErrorMessage} >
            <Alert onClose={dataReportGroup.handleCloseErrorMessage} severity="error" sx={{ width: '100%', backgroundColor: 'black', color: 'white' }}>
              {dataReportGroup.messageError}
            </Alert>
          </Snackbar>
          :
          null
      }
      {
        dataReportGroup.succesMessageBoolean ?
          <Snackbar open={dataReportGroup.succesMessageBoolean} autoHideDuration={3000} onClose={dataReportGroup.handleCloseMessageSucces} >
            <Alert onClose={dataReportGroup.handleCloseMessageSucces} severity="success" sx={{ width: '100%', backgroundColor: 'black', color: 'white' }}>
              {dataReportGroup.succesMessage}
            </Alert>
          </Snackbar>
          :
          null
      }
      <MyTable
        data={dataReportGroup.data}
        handleMenuOpen={handleMenuOpen}
        handleMenuOpenAtividade={dataReportGroup.handleMenuOpenAtividade}
        handleClickIncomplets={handleClickIncomplets}
        setOpenAddPoint={handleOpenADDpoint}
        countColumns={dataReportGroup.countColumns}
        handleOpenADDpoint={handleOpenADDpoint}
        loadingHistory={dataReportGroup.loadingHistory}
        startLoading={dataReportGroup.startLoading}
        idCreatedTimesheet={dataReportGroup.idCreatedTimesheet}
        setOpenHistory={dataReportGroup.setOpenHistory}
        historyModal={dataReportGroup.historyModal}
      />

      <TreatmentPoint
        open={dataReportGroup.openTreatmentPoint}
        onClose={dataReportGroup.setOpenTreatmentPoint}
        onCloseTreatment={dataReportGroup.onCloseTreatment}
        editPoint={dataReportGroup.editPoint}
        setEditPoint={dataReportGroup.setEditPoint}
      />

      <EditarPonto
        open={dataReportGroup.editPoint}
        onClose={dataReportGroup.setEditPoint}
        row={dataReportGroup.row}
        setDtRegisterUpdate={dataReportGroup.setDtRegisterUpdate}
        setJustificationUpdate={dataReportGroup.setJustificationUpdate}
        dtRegisterUpdate={dataReportGroup.dtRegisterUpdate}
        justficationUpadate={dataReportGroup.justficationUpadate}
        updateTimesheet={dataReportGroup.updateTimesheet}
        setType={dataReportGroup.setType}
        timesheetRow={dataReportGroup.timesheetRow}
        type={dataReportGroup.type}
        handleMenuCloseAtividade={dataReportGroup.handleMenuCloseAtividade}
        setMenuTimesheet={dataReportGroup.setMenuTimesheet}
        startLoading={dataReportGroup.startLoading}
      />

      <AddPoint
        openADD={dataReportGroup.addPoint}
        onCloseADD={dataReportGroup.setAddPoint}
        setType={dataReportGroup.setType}
        setDtRegisterADD={dataReportGroup.setDtRegisterADD}
        setJustificationADD={dataReportGroup.setJustificationADD}
        row={dataReportGroup.row}
        creatTimesheet={dataReportGroup.creatTimesheet}
        handleMenuCloseAtividade={dataReportGroup.handleMenuCloseAtividade}
        handleCloseAdd={handleCloseAdd}
        type={dataReportGroup.type}
        dtRegisterADD={dataReportGroup.dtRegisterADD}
        startLoading={dataReportGroup.startLoading}
      />

      <DeleteTimesheet
        timesheetDelete={dataReportGroup.timesheetDelete}
        closeModalTimesheetDelete={closeModalDeleteTimesheet}
        setJustificationDelete={dataReportGroup.setJustificationDelete}
        deleteTimesheet={dataReportGroup.deleteTimesheet}
        handleMenuCloseAtividade={dataReportGroup.handleMenuCloseAtividade}
        setMenuTimesheet={dataReportGroup.setMenuTimesheet}
        startLoading={dataReportGroup.startLoading}
      />

      <Allowance
        open={dataReportGroup.openModalAllowance}
        typesAllowaces={dataReportGroup.typesAllowaces}
        observationsAllowance={dataReportGroup.observationsAllowance}
        typesReduce={dataReportGroup.typesReduce}
        typesHome={dataReportGroup.typesHome}
        onClose={dataReportGroup.handleCloseAllowance}
        handleInputTimeAndHoraryAllowance={dataReportGroup.handleInputTimeAndHoraryAllowance}
        setJustificationChange={dataReportGroup.setJustificationChange}
        dateAllowance={dataReportGroup.dateAllowance}
        horaryAllowance={dataReportGroup.horaryAllowance}
        justificationChange={dataReportGroup.justificationChange}
        setValueAllowance={dataReportGroup.setValueAllowance}
        valueAllowance={dataReportGroup.valueAllowance}
        handleAllowanceClick={dataReportGroup.handleAllowanceClick}
        row={dataReportGroup.row}
        setRuleDECLARATION_ATTENDANCE={dataReportGroup.setRuleDECLARATION_ATTENDANCE}
        ruleDECLARATION_ATTENDANCE={dataReportGroup.ruleDECLARATION_ATTENDANCE}
        setRuleHOME_OFFICE={dataReportGroup.setRuleHOME_OFFICE}
        ruleHOME_OFFICE={dataReportGroup.ruleHOME_OFFICE}
        dtTo={dataReportGroup.dtTo}
        dtFrom={dataReportGroup.dtFrom}
        deleteVacations={dataReportGroup.deleteVacations}
      />
      {
        dataReportGroup.timesheetRow ?
          <ActionsTimesheet
            openModalActionsTimesheet={dataReportGroup.openModalActionsTimesheet}
            handleOpenActionsModal={dataReportGroup.handleOpenActionsModal}
            handleCloseActionsModal={dataReportGroup.handleCloseActionsModal}
            modalPicture={dataReportGroup.modalPicture}
            handleClosePicture={dataReportGroup.handleClosePicture}
            fotoModal={dataReportGroup.fotoModal}
            handleViewPicture={handleViewPicture}
            viewLocation={dataReportGroup.viewLocation}
            handleCloseViewLocation={dataReportGroup.handleCloseViewLocation}
            handleViewLocation={dataReportGroup.handleViewLocation}
            timesheetRow={dataReportGroup.timesheetRow}
            handleOpenPicture={dataReportGroup.handleOpenPicture}
            evetnMap={dataReportGroup.evetnMap}
          /> : null
      }

      <ActivityWorkDay
        open={dataReportGroup.openHistory}
        row={dataReportGroup.row}
        setOpenHistory={dataReportGroup.setOpenHistory}
        handleMenuOpen={handleMenuOpen}
        updateTimsheet={dataReportGroup.updateTimsheet}
        handleOpenActionsModal={dataReportGroup.handleOpenActionsModal}
        handleOpenModalUpdate={dataReportGroup.handleOpenModalUpdate}
        openModalTimesheetDelete={dataReportGroup.openModalTimesheetDelete}
        timesheetRow={dataReportGroup.timesheetRow}
        setType={dataReportGroup.setType}
        setRow={dataReportGroup.setRow}
        setTimesheetRow={dataReportGroup.setTimesheetRow}
        succesMessage={dataReportGroup.succesMessage}
        data={dataReportGroup.data}
        schedule={dataReportGroup.schedule}
        processRow={dataReportGroup.processRow}
        ocultarPontosRemovidos={dataReportGroup.ocultarPontosRemovidos}
        setOcultarPontosRemovidos={dataReportGroup.setOcultarPontosRemovidos}
        arrayOrdenado={dataReportGroup.arrayOrdenado}
        menuTimesheet={dataReportGroup.menuTimesheet}
        setMenuTimesheet={dataReportGroup.setMenuTimesheet}
        diffTimeSchedule={dataReportGroup.diffTimeSchedule}
        loadingHistory={dataReportGroup.loadingHistory}
        startLoading={dataReportGroup.startLoading}
        setOpenAddPoint={dataReportGroup.setOpenAddPoint}
        handleOpenADDpoint={dataReportGroup.handleOpenModalADD}
        dataReportGroup={dataReportGroup}
        menuTimesheetRemoved={dataReportGroup.menuTimesheetRemoved}
        setMenuTimesheetRemoved={dataReportGroup.setMenuTimesheetRemoved}
      />

      <Menu
        id="simple-menu"
        anchorEl={dataReportGroup.openMenuTimesheet}
        keepMounted
        open={open}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            border: '1px solid white', // Definindo a cor da borda como branca
            borderColor: 'white',
            backgroundColor: 'rgba(255, 255, 255, 0.95)', // Cor de fundo do menu
            boxShadow: 'none'
          },
        }}

      >
        <MenuItem onClick={dataReportGroup.handleOpenActionsModal}>Ver detalhes</MenuItem>
        <MenuItem onClick={dataReportGroup.handleOpenModalUpdate}>Editar ponto</MenuItem>
        <MenuItem onClick={dataReportGroup.updateTimsheet}>Alterar para {dataReportGroup.timesheetRow ? dataReportGroup.timesheetRow.type == 'Entrada' ? 'saída' : 'entrada' : null}</MenuItem>
        <MenuItem onClick={dataReportGroup.openModalTimesheetDelete}>Excluir</MenuItem>

      </Menu>
      <Menu
        id="simple-menu"
        anchorEl={menuIncomplets}
        keepMounted
        open={menuIncomplets}
        onClose={handleCloseMenuIncomplets}
        PaperProps={{
          style: {
            border: '1px solid white', // Definindo a cor da borda como branca
            borderColor: 'white',
            backgroundColor: 'rgba(255, 255, 255, 0.95)', // Cor de fundo do menu
            boxShadow: 'none'
          },
        }}

      >
        {
          dataReportGroup.row && dataReportGroup.row.incompletShift ? dataReportGroup.row.incompletShift.map((incompletShift, index) => {
            const shift = incompletShift.clockIn ? incompletShift.clockIn : incompletShift.clockOut
            const type = incompletShift.type
            const label = type + ':' + ' ' + shift
            return (
              <div key={index}>
                <NestedMenuItem
                  label={label}
                  parentMenuOpen={menuIncomplets}
                  anchorEl={menuIncomplets}
                  onMouseEnter={(event) => handleNestedMenuItemHover(event, incompletShift)}
                >
                  <MenuItem onClick={dataReportGroup.handleOpenActionsModal}>Ver detalhes</MenuItem>
                  <MenuItem onClick={dataReportGroup.handleOpenModalUpdate}>Editar ponto</MenuItem>
                  <MenuItem onClick={dataReportGroup.openModalTimesheetDelete}>Excluir</MenuItem>
                </NestedMenuItem>
              </div>
            )
          })
            : null
        }
      </Menu>

      <Menu
        id="simple-menu"
        anchorEl={dataReportGroup.anchorElAtividade}
        keepMounted
        open={openAtividade}
        onClose={dataReportGroup.handleMenuCloseAtividade}
        PaperProps={{
          style: {
            border: '1px solid white', // Definindo a cor da borda como branca
            borderColor: 'white',
            backgroundColor: 'rgba(255, 255, 255, 0.95)', // Cor de fundo do menu
            boxShadow: 'none'
          },
        }}
      >
        <MenuItem onClick={dataReportGroup.handleOpenModalADD}>Adicionar ponto</MenuItem>
        <MenuItem onClick={dataReportGroup.handleOpenAllowance}>Abonar dia</MenuItem>
        <MenuItem onClick={dataReportGroup.historyModal}>Resumo do dia</MenuItem>
      </Menu>

      <Menu
        id="simple-menu"
        anchorEl={dataReportGroup.openAddPoint}
        keepMounted
        open={Boolean(dataReportGroup.openAddPoint)}
        onClose={handleCloseAdd}
        PaperProps={{
          style: {
            border: '1px solid white', // Definindo a cor da borda como branca
            borderColor: 'white',
            backgroundColor: 'rgba(255, 255, 255, 0.95)', // Cor de fundo do menu
            boxShadow: 'none'
          },
        }}
      >
        <MenuItem onClick={dataReportGroup.handleOpenModalADD}>Adicionar ponto</MenuItem>
      </Menu>
    </Grid >
  );
}

export default ReportData;


